import React from 'react';
import { Box, Typography } from '@mui/material';
import { NOTE_MAX_LENGTH, noteLimitError } from '../../utils/noteLimits';

const ERROR_RED = '#EB5757';
const MUTED = '#9ca3af';

// Character counter for a note field, plus the error that explains why typing
// stopped once the field is full. Every note field in the app shares this so the
// wording and the limit can never drift apart.
//
// `inline` renders it as a row under the field; the default renders both pieces
// absolutely, for the note boxes that reserve a strip at the bottom for them.
const NoteLimitCounter = ({ value, label = 'Note', inline = false }) => {
    const length = (value || '').length;
    const message = noteLimitError(value, label);
    const atLimit = !!message;
    const countSx = {
        fontSize: '11px',
        color: atLimit ? ERROR_RED : MUTED,
        fontFamily: atLimit ? 'helvetica-lt-std-bold' : 'inherit',
    };

    if (inline) {
        return (
            <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', gap: 1, mt: '2px' }}>
                {/* Kept in the layout even when hidden so the row can't jump. */}
                <Typography sx={{ fontSize: '11px', color: ERROR_RED, fontFamily: 'helvetica-lt-std-bold', visibility: atLimit ? 'visible' : 'hidden' }}>
                    {message}
                </Typography>
                <Typography sx={{ ...countSx, flexShrink: 0 }}>{length}/{NOTE_MAX_LENGTH}</Typography>
            </Box>
        );
    }

    return (
        <>
            {atLimit && (
                <Typography sx={{
                    position: 'absolute', left: 12, bottom: 6, right: '76px',
                    fontSize: '11px', color: ERROR_RED, fontFamily: 'helvetica-lt-std-bold',
                    whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis',
                }}>
                    {message}
                </Typography>
            )}
            <Typography sx={{ ...countSx, position: 'absolute', right: 10, bottom: 6 }}>
                {length}/{NOTE_MAX_LENGTH}
            </Typography>
        </>
    );
};

export default NoteLimitCounter;
